"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePublishRequest = parsePublishRequest;
exports.parseSubscribeRequest = parseSubscribeRequest;
exports.parseSubscriptionRequest = parseSubscriptionRequest;
exports.parseUnsubscribeRequest = parseUnsubscribeRequest;

var _misc = require("./misc");

var _validators = require("./validators");

function parseSubscribeRequest(request) {
  if (!(0, _validators.isSubscribeMethod)(request.method)) {
    throw new Error("JSON-RPC Request has invalid subscribe method");
  }

  if (!(0, _validators.isSubscribeParams)(request.params)) {
    throw new Error("JSON-RPC Request has invalid subscribe params");
  }

  var params = request.params;
  (0, _misc.assertType)(params, "topic");
  return params;
}

function parsePublishRequest(request) {
  if (!(0, _validators.isPublishMethod)(request.method)) {
    throw new Error("JSON-RPC Request has invalid publish method");
  }

  if (!(0, _validators.isPublishParams)(request.params)) {
    throw new Error("JSON-RPC Request has invalid publish params");
  }

  var params = request.params;
  (0, _misc.assertType)(params, "topic");
  (0, _misc.assertType)(params, "message");
  (0, _misc.assertType)(params, "ttl", "number");
  return params;
}

function parseUnsubscribeRequest(request) {
  if (!(0, _validators.isUnsubscribeMethod)(request.method)) {
    throw new Error("JSON-RPC Request has invalid unsubscribe method");
  }

  if (!(0, _validators.isUnsubscribeParams)(request.params)) {
    throw new Error("JSON-RPC Request has invalid unsubscribe params");
  }

  var params = request.params;
  (0, _misc.assertType)(params, "id");
  return params;
}

function parseSubscriptionRequest(request) {
  if (!(0, _validators.isSubscriptionMethod)(request.method)) {
    throw new Error("JSON-RPC Request has invalid subscription method");
  }

  if (!(0, _validators.isSubscriptionParams)(request.params)) {
    throw new Error("JSON-RPC Request has invalid subscription params");
  }

  var params = request.params;
  (0, _misc.assertType)(params, "id");
  (0, _misc.assertType)(params, "data");
  return params;
}